import {gql} from '@apollo/client'

// Fragment para los campos comunes de Resource Center
const RESOURCE_CENTER_FIELDS = gql`
  fragment ResourceCenterFields on resource_center_type {
    id
    name
    description
    file
    url
    thumbnail
    resourceType
    documentTag {
      id
      tagName
    }
    category {
      id
      name
    }
    comments
    user {
      id
      firstName
      lastName
    }
    organization {
      id
      name
    }
    isActive
    isCampaignMedia
    order
    viewsCount
    created
    updated
  }
`

// Query para obtener todos los recursos con filtros
export const GET_ALL_RESOURCES_CENTER = gql`
  ${RESOURCE_CENTER_FIELDS}
  query getAllResourcesCenter(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    allResourcesCenter(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      edges {
        node {
          ...ResourceCenterFields
        }
      }
      totalCount
    }
  }
`

// Query para obtener un recurso por ID
export const GET_RESOURCE_CENTER_BY_ID = gql`
  ${RESOURCE_CENTER_FIELDS}
  query getResourceCenterById($id: String!) {
    resourceCenterById(id: $id) {
      ...ResourceCenterFields
    }
  }
`

// Query para obtener recursos activos
export const GET_RESOURCES_CENTER_ACTIVE = gql`
  ${RESOURCE_CENTER_FIELDS}
  query getResourcesCenterActive {
    resourcesCenterActive {
      ...ResourceCenterFields
    }
  }
`

// Query para obtener recursos por tipo
export const GET_RESOURCES_CENTER_BY_TYPE = gql`
  ${RESOURCE_CENTER_FIELDS}
  query getResourcesCenterByType($resourceType: String!) {
    resourcesCenterByType(resourceType: $resourceType) {
      ...ResourceCenterFields
    }
  }
`

// Query para búsqueda avanzada
export const SEARCH_RESOURCES_CENTER = gql`
  ${RESOURCE_CENTER_FIELDS}
  query searchResourcesCenter(
    $name: String
    $resourceType: String
    $tagName: String
    $isActive: Boolean
    $isCampaignMedia: Boolean
    $categoryId: Int
    $includeSubcategories: Boolean
  ) {
    resourcesCenterAdvancedSearch(
      name: $name
      resourceType: $resourceType
      tagName: $tagName
      isActive: $isActive
      isCampaignMedia: $isCampaignMedia
      categoryId: $categoryId
      includeSubcategories: $includeSubcategories
    ) {
      ...ResourceCenterFields
    }
  }
`
